import { ButtonLink } from "@/components/ui/Button";
import { PrimaryCta } from "@/components/ui/PrimaryCta";
import { AuroraField } from "@/components/visuals/AuroraField";
import { useLocale } from "@/i18n";

export function FinalCta() {
  const { t, path } = useLocale();

  return (
    <section className="relative overflow-hidden border-t border-white/8">
      <AuroraField variant="edge" />

      <div className="container-page relative py-24 text-center md:py-32">
        <h2 className="text-display mx-auto max-w-2xl text-3xl leading-tight font-semibold sm:text-4xl md:text-5xl">
          {t.finalCta.title}
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-base text-cream-100/60 md:text-lg">
          {t.finalCta.body}
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <PrimaryCta size="lg" className="w-full sm:w-auto" />
          <ButtonLink
            to={path("/contact")}
            variant="secondary"
            size="lg"
            className="w-full sm:w-auto"
          >
            {t.cta.contact}
          </ButtonLink>
        </div>

        <p className="mt-8 text-sm text-cream-100/40">{t.finalCta.note}</p>
      </div>
    </section>
  );
}
